<template>
  <div class="login-form">
    <div class="loginWrap">
      <h6 class="tt">ADMIN LOGIN</h6>
      <div class="inner">
        <div class="input-box dflexS">
          <i class="fi fi-rr-user"></i>
          <input type="text" aria-label="체험 아이디" readonly id="adminId" v-model="model.siteId" />
        </div>
        <div class="input-box dflexS">
          <i class="fi fi-rr-lock"></i>
          <input type="password" aria-label="비밀번호" placeholder="비밀번호" id="adminPw" v-model="model.sitePass" @keyup.enter="onSubmit" />
        </div>
        <p>포트폴리오 데모 · 비밀번호 <strong>1234</strong></p>
        <p>가상 데이터만 표시하며 운영 서버에는 연결하지 않습니다.</p>
        <p v-if="loginError" role="alert">{{ loginError }}</p>
        <button class="signIn" type="button" :disabled="isSubmitting" @click="onSubmit">{{ isSubmitting ? '처리 중...' : 'LOGIN' }}</button>
      </div>
    </div>
    <p class="loginFooter">ADMIN · PORTFOLIO DEMO</p>
  </div>
</template>

<script>
import { getAuthToken, getSiteData, setAuthData } from '@/libs/auth-helper'
import { signIn } from '@/api/member'
import store from '@/store'
export default {
  data () { return { model: { siteId: 'admin', sitePass: '' }, isSubmitting: false, loginError: '' } },
  methods: {
    async onSubmit () {
      if (this.isSubmitting) return
      this.isSubmitting = true
      this.loginError = ''
      try {
        const res = await signIn({ siteId: 'admin', sitePass: this.model.sitePass })
        if (res.resultCode !== '0') {
          this.loginError = res.resultMessage
          return
        }
        setAuthData(res.data)
        await store.dispatch('storeMenuDate')
        await this.$router.replace('/dash')
      } catch (error) {
        this.loginError = '데모 화면을 열지 못했습니다. 다시 시도해주세요.'
      } finally {
        this.isSubmitting = false
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(getAuthToken() && getSiteData() ? '/dash' : undefined)
  }
}
</script>

<style scoped>
.login-form {
   position: fixed;
   top: 50%;
   left: 50%;
   transform: translate(-50%, -50%);
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
.login-form h1 {text-align: center;font-size: 47px;color: #fff;font-family: 'GillSansNova';}
.login-form h2 {text-align: center;font-size: 25px; color: #fff; margin-bottom: 75px;}
.loginWrap {
  width: 404px;
  display: flex;
  flex-direction: column;
  gap: 0px;
  background: #131b29;
  border-radius: 10px;
  overflow: hidden;
}
.loginWrap h6 {background: #1a2230;display: flex;align-items: center;justify-content: center;height: 50px;font-size: 21px;font-weight: 700;}
.loginWrap .inner {padding: 20px;display: flex;flex-direction: column;gap: 15px;}
.input-box {
  position: relative;
  width: 100%;
  border: 1px solid #313a49;
  border-radius: 8px;
  overflow: hidden;
  padding:0 0px 0 10px;
  height: 44px;gap: 10px;
}
.input-box img {
  width: 18px;
  margin-right: 20px;
}
.input-box input {
  border-radius: 5px;
  width: 100%;
  height: 100%;
  background:none;
  font-size: 14px;
  color: #fff;
  border: 0 !important;
  padding:0 0 0 15px;
}
.input-box input[type="password"] {
  letter-spacing: 4px;
}
.input-box input::placeholder {
  letter-spacing: 0px;
  color: #bfbfbf;
  font-size: 14px;
}
.inputchk-box {display: flex;align-items: center;gap: 7px;color: #fff;}
.inputchk-box input {border: 1px solid #545454;width: 19px;height: 19px;}
.signIn {
  width: 100%;
  height: 44px;
  font-size: 18px;
  font-weight: bold;
  border-radius: 8px;
  background: #30ba79;
  border: 1px solid #30ba79;
  color: #fff;
  cursor: pointer;
}
.signIn:hover {
  filter: brightness(1.1);
}
.loginFooter {
  color: #8a8a8c;
  margin-top: 10px;
  font-size: 16px;
  text-align: center;
}
.loginFooter span {
  color: #30ba79;
}
.modal-wrapper {
  display: flex;
  font-size: 16px;
  align-items: center;
}
.signIn.close {
  background: red;
  border: 2px solid red;
}
.signIn.close:hover {
  background: #fff;
  color: red;
}
.sub-title {
  font-size: 14px;
  height: 42px;
  position: relative;
  margin-bottom: 30px;
  border-bottom: 3px solid #e1534e;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sub-title a {position: absolute;right: 15px;}
.sub-title a img {vertical-align: middle;}
.sub-title > h3 {
  color: #fff;
  padding: 0;
  position: relative;
}
.modal-wrap {
  border: 3px solid #d65b1c;
  min-width: unset;
  width: 24%;
  min-width: 550px;
  background: #353535;
  padding: 0;
  margin: 0;
}
.modal-wrap .input-box {
  width: 400px;
  gap: 25px;
}
.modal-wrap .input-box input {height: 63px;padding: 0;text-align: center;}
.page-content {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0 0 27px;
}
.page-contents-wrap {
  background: none;
  padding: 0;
}
.modal-wrap .signIn {
  margin-top: 0;
  width: 100%;
  background: #30ba79;
  width: 168px;
  height: 35px;
  font-size: 18px;
  font-weight: normal;
}
.modal-wrap .signIn:hover {
  background: #fff;
  color: #30ba79;
}
.status-change-btn-wrap {
  width: 100%;
  gap: 5px;
  margin-top: 27px;
}

.captcha-box {

}
.captcha-box .vue_client_recaptcha {
  background-color: #8194ff;
  width: 52%;
  height: 44px;
  display: flex;align-items: center;
  flex-direction: row-reverse;
  border-radius: 5px;padding: 0 10px;
}

.captcha-box .input {
  position: relative;
  float: right;
  width: calc(48% - 15px);
  height: 44px;
  text-align: center;
  font-size:14px;
  letter-spacing: -0.025em;
  box-shadow: 0 0 6px 0 rgb(0 0 0 / 16%);
  border: solid 1px #313a49;
  background:none;
  color: #fff;
  vertical-align: top;
  margin-left: 15px;
  padding: 0;
  border-radius: 8px;
}

@media (max-width: 500px) {
  .login-form {display: block;padding-top: 50px;}
  .loginWrap{
    width: 350px;
    height: auto;
    background: none;
    padding: 0;
    margin: 0 auto;
  }
  .login-form h1 {font-size: 40px;margin-bottom: 20px;}
  .login-form h2 {display: none;}
  .input-box input{
    height: 43px;
  }
  .signIn {height: 43px;}
  .captcha-box .vue_client_recaptcha{display: flex;width: 60%;height: 42px;}
  .captcha-box .input {
    width: calc(48% - 0px);
    height: 42px;
    margin-left: 10px;
  }
  .modal-wrapper {display: block;}
  .modal-wrap {min-width: 320px;position: fixed;left: 50%;transform: translateX(-50%);top: 65px;}
  .modal-wrap .input-box {width: 100%;}
  .modal-wrap .input-box input {height: 43px;}
}
</style>
<style scoped src="@/assets/fonts/GillSansNova.css"></style>
